import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["mobileSidebar", "panel", "backdrop"];

    connect() {
        this.mobileSidebarTarget.classList.add("hidden");
    }

    open() {
        this.mobileSidebarTarget.classList.remove("hidden");
        document.body.style.overflow = "hidden";
        // Defer so the browser paints the element before animating
        requestAnimationFrame(() => {
            this.panelTarget.classList.remove("translate-x-full");
            this.panelTarget.classList.add("translate-x-0");
            this.backdropTarget.classList.remove("opacity-0");
            this.backdropTarget.classList.add("opacity-100");
        });
    }

    close() {
        this.panelTarget.classList.add("translate-x-full");
        this.panelTarget.classList.remove("translate-x-0");
        this.backdropTarget.classList.add("opacity-0");
        this.backdropTarget.classList.remove("opacity-100");
        document.body.style.overflow = "";
        setTimeout(() => {
            this.mobileSidebarTarget.classList.add("hidden");
        }, 300);
    }
}
